<div class="cards ml-4" *ngIf="cardsRodada.length > 0; else cardPadrao">
    <div class="card-item" *ngFor="let card of cardsRodada">
        <card-primecap
          [cardClass]="cardClass"
          [cardRodada]="card"
          (clickButton)="redirecionarDetalhesCard(card)">
          <button-primecap buttonClass="primario-button-g" label="{{ labelBotao }}"></button-primecap>
        </card-primecap>
    </div>
</div>


<ng-template class="cards" #cardPadrao>
  <div class="cards ml-4">
    <div class="card-item">
      <card-primecap [cardClass]="cardClass"></card-primecap>
    </div>
  </div>
</ng-template>
